'use client';

import { usePathname } from 'next/navigation';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { stack } from '@/uiPrimitives/layout/stack';
import { textBlock } from '@/uiPrimitives/typography/text';
import { H2TextBlock } from '@/uiComposites/typography/headings';

import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { select } from '@/uiComposites/form/select.css';
import { pushInternalLinkEvent } from '@/globals/analytics/events/pushLinkEvent';
import { useDOPRouter } from '@/globals/routing/DOPRouter';
import { WebAPIDetacherenSearchBox } from '@/globals/webApiTypes/elements/WebAPIDetacheren';
import { useId } from 'react';

export const DetacherenCountries = ({
	data,
}: {
	data: WebAPIDetacherenSearchBox;
}) => {
	const router = useDOPRouter();
	const baseUrl = usePathname();
	let defaultURl = baseUrl;
	const redirectURL = defaultURl.split('/');
	defaultURl = defaultURl.replace(
		redirectURL[redirectURL.length - 2] + '/',
		'',
	);

	const countrySelectId = useId();

	return (
		<div
			className={classes(
				box({
					backgroundColor: 'negativeBlueEmphasis',
					paddingInline: '5 | betweenParagraphs',
					paddingBlockEnd: '5 | betweenParagraphs',
					paddingBlockStart: '4 | betweenListItems',
				}),
			)}
		>
			<span className={classes(stack({ rowGap: '3 | h1' }))}>
				{data.subtitle !== null && <H2TextBlock>{data.subtitle}</H2TextBlock>}
				<label
					htmlFor={countrySelectId}
					className={classes(textBlock({ capSize: '0 | p' }))}
				>
					{data.title}
				</label>
				<select
					id={countrySelectId}
					name="detacheren-country-select"
					defaultValue={baseUrl}
					className={classes(select)}
					onChange={(event) => {
						const href = event.currentTarget.value;
						router.push(href, { scroll: false });
						pushInternalLinkEvent({
							href,
							linkType: 'countryChanged',
						});
					}}
					{...addTestSelector('detacherenSelectCountry')}
				>
					<option value={defaultURl}>{data.placeholder}</option>
					{data.countries.map(({ country, href }, i) => (
						<option
							key={i}
							value={href}
							className={classes(box({ padding: '-1 | small' }))}
						>
							{country}
						</option>
					))}
				</select>
			</span>
		</div>
	);
};
